// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/text-search.js';

import { paths } from '../generated/text-search';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('text-search', Original, paths);
